import React from "react";

import { loadMathJax } from "@courses-pm2/mathjax-util-component/src/ts/utils/loadMathJax";

/**
 * Creates a wrapper around the content, making sure that MathJax will be
 * applied to it.
 */
// tslint:disable-next-line variable-name
export class MathJaxUtil extends React.PureComponent<{ children?: React.ReactNode }> {
    /**
     * Will contain a reference to the wrapper element, so we can easily access
     * it and apply MathJax on it when mounted into the ODM.
     */
    protected readonly wrapperRef: React.RefObject<HTMLSpanElement | null> = React.createRef();

    /**
     * Typeset MathJax initially when the component is just mounted.
     */
    public componentDidMount(): void {
        this.typeSet();
    }

    /**
     * Primary render method.
     */
    public render(): React.JSX.Element {
        return (
            <span ref={this.wrapperRef}>
                {this.props.children}
            </span>
        );
    }

    /**
     * Helper that'll typeset LateX within the component using MathJax, turning
     * it into visual formulas.
     */
    protected typeSet(): void {
        // Wait for MathJax to be loaded
        loadMathJax()
            .then(
                () => {
                    if (this.wrapperRef.current) {
                        MathJax.Hub.Queue(["Typeset", MathJax.Hub, this.wrapperRef.current]);
                    }
                },

                () => { /* Ignore errors loading MathJax silently */ },
            );
    }
}
